import { render, staticRenderFns } from "./LMSIntegrationSettings.vue?vue&type=template&id=6467aa00&scoped=true"
import script from "./LMSIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./LMSIntegrationSettings.vue?vue&type=script&lang=js"
import style0 from "./LMSIntegrationSettings.vue?vue&type=style&index=0&id=6467aa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467aa00",
  null
  
)

export default component.exports